export interface IWebsiteSidebarSimpleItemData {
  name: string;
  label: string;
  img?: string;
  icon?: string;
  path?: string;
  actions?: string[];
  disabled?: boolean;
  hidden?: boolean;
  notification?: boolean;
  beta?: boolean;
  externalLink?: boolean;
  showUpgrade?: boolean;
  advanced?: boolean;
}

export const WEBSITE_SIDEBAR_SIMPLE_ITEMS_DATA: { [key: string]: IWebsiteSidebarSimpleItemData } = {
  mySites: {
    name: 'mySites', label: 'text_mySites',
    icon: 'db-icon-ds-websites', path: '/my-sites'
  },

  main: {
    name: 'main', label: 'text_main',
    icon: 'db-icon-ds-sidebar-main', path: '/main',
    advanced: true
  },

  credentials: {
    name: 'credentials', label: 'text_hosting.info',
    path: '/hosting/info',
    advanced: true
  },

  domains: {name: 'domains', label: 'text_hosting.domains', path: '/domains', icon: 'db-icon-ds-sidebar-domain'},

  tools: {
    name: 'tools', label: 'text_hosting.tools',
    path: '/hosting/tools',
    advanced: true
  },

  redirects: {
    name: 'redirects', label: 'text_hosting.redirects',
    path: '/hosting/redirects',
    advanced: true
  },

  resource: {
    name: 'resource', label: 'text_hosting.resource-usage',
    path: '/hosting/resource-usage',
    advanced: true
  },

  logs: {
    name: 'logs', label: 'text_logs',
    path: '/hosting/logs',
    advanced: true
  },

  staging: {
    name: 'staging', label: 'text_stagingEnvironment',
    path: '/hosting/environment',
    advanced: true
  },

  stagingEnabled: {
    name: 'staging', label: 'text_stagingEnvironment',
    actions: [JSON.stringify({name: 'changeEnv', args: [true]})],
    advanced: true
  },

  manage: {
    name: 'manage', label: 'text_hosting.manage_environment',
    path: '/hosting/manage-environment',
    advanced: true
  },

  builder: {
    name: 'builder', label: 'text_ai-builder.title',
    icon: 'db-icon-ds-sidebar-builder', path: '/ai-builder'
  },

  recreate: {
    name: 'recreate', label: 'text_ai-builder.recreate-menu',
    path: '/builder/recreate-website'
  },

  templates: {
    name: 'templates', label: 'text_ai-builder.templates',
    path: '/builder/templates'
  },

  plugins: {
    name: 'plugins', label: 'text_managerWPPlugins',
    path: '/plugins',
    advanced: true,
    showUpgrade: false
  },

  themes: {
    name: 'themes', label: 'text_managerWPThemes',
    path: '/themes',
    advanced: true,
    showUpgrade: false
  },

  backup: {
    name: 'backup', label: 'text_backups',
    icon: 'db-icon-ds-sidebar-backup', path: '/backup'
  },

  security: {
    name: 'security', label: 'text_security',
    path: '/security'
  },

  seo: {
    name: 'seo', label: 'text_seo',
    icon: 'db-icon-ds-seo-new', path: '/seo'
  },

  imageOptimizer: {
    name: 'imageOptimizer', label: 'text_imageOptimizer',
    icon: 'db-icon-ds-sidebar-booster', path: '/image-optimizer'
  },

  whiteLabel: {
    name: 'whiteLabel', label: 'text_white-label',
    icon: 'db-icon-ds-white-label', path: '/white-label'
  },

  referralProgram: {
    name: 'referralProgram', label: 'text_referralProgram',
    icon: 'db-icon-ds-referral', path: '/referral-system/program'
  },

  boosterMain: {
    name: 'frontend', label: 'text_main',
    path: '/booster/frontend',
    advanced: true
  },

  boosterMainDisabled: {
    name: 'disabled', label: 'text_main',
    path: '/booster/disabled',
    advanced: true
  },

  boosterPages: {name: 'pages', label: 'text_speedOptimizerPages', path: '/booster/pages'},

  boosterImageOptimizer: {
    name: 'image-optimizer', label: 'text_imageOptimizer',
    path: '/booster/image-optimizer'
  },

  boosterCloudflare: {
    name: 'cloudflare', label: 'text_speedOptimizerCloudflare',
    path: '/booster/cloudflare'
  },

  boosterSettings: {
    name: 'settings', label: 'text_settings',
    path: '/booster/settings'
  },

  boosterHostingPerformance: {
    name: 'backend', label: 'text_speedOptimizerBackEnd',
    path: '/booster/hosting-performance'
  },

  boosterHostingPerformanceForHosted: {
    name: 'hosting-performance', label: 'text_speedOptimizerBackEnd',
    path: '/hosting/hosting-performance'
  },

  boosterPro: {
    name: 'boosterPro', label: 'text_speedOptimizerPro',
    path: '/booster/pro'
  },

  boosterDisconnected: {
    name: 'boosterDisabled', label: 'text_speedOptimizer',
    path: '/booster/disabled'
  },

  boosterWhiteLabel: {name: 'white-label', label: 'text_white-label', path: '/booster/white-label'},

  orders: {
    name: 'orders',
    label: 'text_ecommerce.orders',
    path: '/ecommerce/orders',
    externalLink: false
  },

  products: {
    name: 'products',
    label: 'text_ecommerce.products',
    path: '/ecommerce/products',
    externalLink: false
  },

  customers: {
    name: 'customers',
    label: 'text_ecommerce.customers',
    path: '/ecommerce/customers',
    externalLink: false
  },

  paymentMethods: {
    name: 'paymentMethods',
    label: 'text_managePaymentTitlePaypal',
    path: '/ecommerce/payment-methods',
    externalLink: false
  },

  analytics: {
    name: 'analytics', label: 'text_ecommerce.analytics',
    icon: 'db-icon-ds-external-link',
    externalLink: true
  },

  marketing: {
    name: 'marketing', label: 'text_ecommerce.marketing',
    icon: 'db-icon-ds-external-link',
    externalLink: true
  },

  shipping: {
    name: 'shipping', label: 'text_ecommerce.shipping',
    icon: 'db-icon-ds-external-link',
    externalLink: true
  },

  settings: {
    name: 'settings',
    label: 'text_settings',
    path: '/ecommerce/settings',
    externalLink: false
  },

  ecommerce: {
    name: 'ecommerce', label: 'text_ecommerce.title',
    path: '/ecommerce',
    icon: 'db-icon-ds-sidebar-ecommerce'
  },
  professional: {
    name: 'professional', label: 'text_professionalTitle',
    path: '/professional',
    icon: 'db-icon-ds-professional'
  },

  overview: {
    name: 'overview',
    label: 'text_seo-overview',
    path: '/ecommerce/overview',
    externalLink: false
  },
  payment: {
    name: 'payment',
    label: 'text_ecommerce.payments',
    path: '/ecommerce/payment-methods',
    externalLink: false
  },
  emails: {
    name: 'emails',
    label: 'text_ecommerce.emails',
    path: '/ecommerce/emails',
    externalLink: false
  },
  tax: {
    name: 'tax',
    label: 'text_ecommerce.tax',
    path: '/ecommerce/tax',
    externalLink: false
  },
};
